import React from 'react'
import {graphql} from 'gatsby'

import Layout from '../../components/Layout'
import ConferenceExpositionSection from '../../components/ConferenceExpositionSection'
import WhyTopicsSection from './components/WhyTopicsSection'
import SpeakersSection from './components/SpeakersSection'
import ProgramSection from './components/ProgramSection'
import PlaceSection from './components/PlaceSection'
import SpotSection from './components/SpotSection'
import SponsorsSection from '../../components/SponsorsSection'
import NewsletterSection from './components/NewsletterSection'


const IndexPage = ({data: dataObj}) => {
	const data = dataObj.conference.childPagesJson.childPagesJsonWithRelativePaths
	return <Layout Layout darkTopBar noTopSpace seo={{routeUrl: data.url, ...data.seo}}>
		<ConferenceExpositionSection linkOutsite noTopWave/>
		<WhyTopicsSection data={data.whyTopic}/>
		<SpeakersSection data={data.speakers}/>
		<ProgramSection data={data.timeline}/>
		<PlaceSection data={data.place}/>
		<SpotSection data={data.spot}/>
		<SponsorsSection withCta/>
		<NewsletterSection/>
	</Layout>
}


export default IndexPage

export const query = graphql`
{
	conference: file(relativePath: {eq: "pages/conferencePage.json"}) {
    childPagesJson {
      childPagesJsonWithRelativePaths {
      	url

      	whyTopic {
      		why {
      			title
      			bullets {
      				textMd
      			}
      		}
      		topics {
      			title
      			list
      		}
      	}

      	speakers {
      		title
      		list {
      			photo {
      			  childImageSharp {
					fixed(width: 200, height: 150, cropFocus: NORTH) {
					  ...GatsbyImageSharpFixed
					}
				   }
      			}
      			name
      			position
      			socials {
      				twitter
      				linkedin
      			}
      			company
      		}
      	}

      	timeline {
      		programs {
      			name
      			date
      			points {
      				name
      				timeRange
      				description
      				type
      			}
      		}
      	}

      	place {
      		aboveName
      		name
      		text
      		button {
      			label
      			link
      		}
      		pastImages {
      			title
      			images {
      				preview: image {
      					childImageSharp {
						  fluid(maxWidth: 500) {
							...GatsbyImageSharpFluid
						  }
						}
      				}
      				full: image {
      					childImageSharp {
						  fluid(maxWidth: 2000) {
							...GatsbyImageSharpFluid
						  }
						}
      				}
      				youtubeUrl
      			}
      		}
      	}
      	
      	spot {
      		title
      		text
      		eventId
      	}

      	seo {
          title
          description
          author
          metaImage {
            publicURL
          }
        }
      }
    }
  }
}
`
